import styled from "@emotion/styled";

export const DashboardContainer = styled.div`
  .dashboard-title {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 24px;
    color: #1f1f1f;
  }

  .stat-card {
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }
  }

  .conversation-card {
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .conversation-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .status-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #595959;
    text-transform: capitalize;
  }

  .status-count {
    font-size: 20px;
    font-weight: 500;
    color: #1f1f1f;
  }

  .status-icon {
    font-size: 18px;
  }
`;
